const translations = {
  title: "Expense Tracker",
  subtitle: "Manage shop operations expenses, investments, and personal profiles.",
  // Tabs
  tab_expenses: "Expenses",
  tab_people: "Expense People",
  tab_withdrawals: "Withdrawals",
  // Expense
  addExpense: "Add Expense",
  expenseDate: "Date",
  expenseCategory: "Category",
  expenseAmount: "Amount (₹)",
  expenseDescription: "Description",
  expensePaidBy: "Paid By",
  expenseReference: "Reference",
  // Categories
  cat_rent: "Rent",
  cat_utilities: "Utilities",
  cat_salary: "Staff Salary",
  cat_inventory: "Inventory Purchase",
  cat_maintenance: "Maintenance",
  cat_transport: "Transport",
  cat_marketing: "Marketing",
  cat_taxes: "Taxes & Fees",
  cat_misc: "Miscellaneous",
  // People
  expensePeople: "Expense People",
  addPerson: "Add Person",
  personName: "Name",
  personType: "Type",
  type_owner: "Owner",
  type_partner: "Partner",
  type_employee: "Employee",
  // Withdrawals
  withdrawals: "Withdrawals",
  addWithdrawal: "Add Withdrawal",
  withdrawalAmount: "Amount (₹)",
  withdrawalDate: "Date",
  withdrawalPerson: "Person",
  withdrawalReason: "Reason",
  // Summary
  totalExpenses: "Total Expenses",
  totalWithdrawals: "Total Withdrawals",
  thisMonth: "This Month",
  thisYear: "This Year",
  // Empty states
  noExpenses: "No expenses recorded.",
  noWithdrawals: "No withdrawals yet.",
  // Columns
  col_date: "Date",
  col_category: "Category",
  col_amount: "Amount",
  col_description: "Description",
  col_paidBy: "Paid By",
  col_action: "Action",
};

export default translations;
